// removed by extract-text-webpack-plugin
module.exports = {"labeledRow":"src-components-ExternalInvest-components-___LabeledRow__labeledRow___jbWGF","addressRow":"src-components-ExternalInvest-components-___LabeledRow__addressRow___1efDm","total":"src-components-ExternalInvest-components-___LabeledRow__total___1WgEu","label":"src-components-ExternalInvest-components-___LabeledRow__label___R0FMY","value":"src-components-ExternalInvest-components-___LabeledRow__value___2gC1P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ExternalInvest/components/LabeledRow.css
// module id = 1237
// module chunks = 3